function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.8638 20.0513C16.3344 20.0513 20.8638 15.5219 20.8638 10.0513C20.8638 4.59049 16.3246 0.0512695 10.854 0.0512695C5.39318 0.0512695 0.86377 4.59049 0.86377 10.0513C0.86377 15.5219 5.40299 20.0513 10.8638 20.0513ZM7.20691 13.9238V9.89441C7.20691 9.17872 7.50102 8.83558 8.08926 8.79637V7.60029C8.08926 5.73754 9.20691 4.49245 10.854 4.49245C12.501 4.49245 13.6187 5.73754 13.6187 7.60029V8.79637C14.2069 8.83558 14.501 9.17872 14.501 9.89441V13.9238C14.501 14.6787 14.1677 15.0219 13.4716 15.0219H8.23632C7.54024 15.0219 7.20691 14.6787 7.20691 13.9238ZM9.14808 8.78656H12.5598V7.48264C12.5598 6.30617 11.8736 5.51205 10.854 5.51205C9.83436 5.51205 9.14808 6.30617 9.14808 7.48264V8.78656Z",
  fill: "#19324D"
});

function SvgLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/Lock.b5df546a.svg";
export { ForwardRef as ReactComponent };